define([
	"dojo/_base/declare",
	"csi/property/Widget",
	"csi/reflection"
], function(declare,Widget,reflection) {

	return declare(Widget, {
		propertyForceImageDimensions: true,
		propertyImageHeight: 256,
		propertyImageWidth: 256,		

		// use .csi-company-branding-image styling from SiteAdmin.styl
		"class": "csi-property-viewable-image",

		_getImageAttributeId: function(/*Number*/height, /*Number*/width) {
			// summary: force to use viewable in case it has transparency - Thumbnail and SmallImage may not support that if system configured for jpg images
			return reflection.ATTR_VIEWABLE;
		}
	});
});